import { render } from "./AllOnlineAppealInfo.vue?vue&type=template&id=071abb17"
import script from "./AllOnlineAppealInfo.vue?vue&type=script&lang=js"
export * from "./AllOnlineAppealInfo.vue?vue&type=script&lang=js"

import "./AllOnlineAppealInfo.vue?vue&type=style&index=0&id=071abb17&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__